import apiClient from "../client"
import {
  ApproveStudentRegistrationPayload,
  RejectStudentRegistrationPayload,
  TodosResponse,
  TodoUnreadCountResponse,
} from "../types/todo"

export async function getTodos() {
  return await apiClient.get<TodosResponse>("todos").json()
}

export async function getTodoUnreadCount() {
  return await apiClient
    .get<TodoUnreadCountResponse>("todos/unread_count")
    .json()
}

export async function acceptLocationTodo(locationId: number) {
  return await apiClient.put(`locations/todos/${locationId}/accept`).json()
}

export async function rejectLocationTodo(locationId: number) {
  return await apiClient.put(`locations/todos/${locationId}/reject`).json()
}

export async function completeTodoAssignment(todoId: number) {
  return await apiClient.put(`todos/${todoId}/complete`).json()
}

export async function sendStudentContractReminder(studentContractId: number) {
  return await apiClient
    .post(`student_contracts/${studentContractId}/send_reminder`)
    .json()
}

export async function approveStudentRegistration({
  studentParams,
}: ApproveStudentRegistrationPayload) {
  await apiClient
    .patch(
      `students/registrations/${studentParams.studentRegistrationId}/approve`,
      {
        json: {
          id: studentParams.studentRegistrationId,
          studentParams: {
            ...studentParams,
          },
        },
      },
    )
    .json()
}

export async function rejectStudentRegistration({
  studentParams,
}: RejectStudentRegistrationPayload) {
  return await apiClient
    .patch(
      `students/registrations/${studentParams.studentRegistrationId}/decline`,
      {
        json: {
          id: studentParams.studentRegistrationId,
          studentParams,
        },
      },
    )
    .json()
}
